import { filtersHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';

export const candidateFamilyModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    relationship: data.relationship,
    occupation: data.occupation,
    phoneIso: data.phone_iso,
    phoneCode: data.phone_code,
    phoneNumber: data.phone_number,
    address: data.address,
    isEmergency: data.is_emergency,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidate: data.candidate ? candidateModel(data.candidate) : null,
});